const path = {
    local: 'http://localhost:8000/api/',
    prod: 'https://api.rapihire.com/api/',
    dev: 'https://apidev.rapihire.com/api/'
}

const base_url = path.prod

export default base_url 
